export enum OccGroup {
    unemployed = `OT04`,
    retired = `OT01`,
    housewife = `OT02`
}

export const disableFieldCheck = new Set<string>(Object.values(OccGroup))